<template>
    <div class="col-lg-5 col-sm-12 box-col-5">
        <div class="card">
          <div class="card-header pb-0">
            <div class="row">
              <div class="col-9">
                <h3>Skill Status</h3>
              </div>
              <div class="col-3 text-end"><vue-feather class="text-muted" type="trending-up"></vue-feather></div>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-container">
              <div id="circlechart">
                <apexchart height="363.7" :options="skill.options" :series="skill.series"></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-7 box-col-7">
        <div class="card">
          <div class="card-header pb-0">
            <div class="row">
              <div class="col-9">
                <h3>Order Status</h3>
              </div>
              <div class="col-3 text-end"><vue-feather class="text-muted" type="shopping-bag"></vue-feather></div>
            </div>
          </div>
          <div class="card-body">
            <div class="chart-container">
              <div id="progress1"><apexchart height="70px" :options="order1.options" :series="order1.series"></apexchart></div>
              <div id="progress2"><apexchart height="70px" :options="order2.options" :series="order2.series"></apexchart></div>
              <div id="progress3"><apexchart height="70px" :options="order3.options" :series="order3.series"></apexchart></div>
              <div id="progress4"><apexchart height="70px" :options="order4.options" :series="order4.series"></apexchart></div>
              <div id="progress5"><apexchart height="70px" :options="order5.options" :series="order5.series"></apexchart></div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import wcharts from '../../../data/widgets/charts/wcharts'
 export default{
    name: 'skillPage',
    data(){
        return{
            order1: wcharts.order1,
            order2: wcharts.order2,   
            order3: wcharts.order3,
            order4: wcharts.order4,
            order5: wcharts.order5,
            skill: wcharts.SkillChart
        }
    }
 }
</script>